/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetTotalTimeOffs} from '../api'

export const useMutationBatchGetTotalTimeOffs = createReactQueryMutationHook('batchGetTotalTimeOffs', batchGetTotalTimeOffs)
